<template>
  <div id="schoolManagementForAdminEdit">
    <div class="container SchoolManagementForAdminEdit admin-wrap">
      <div class="row header mb-5">
        <div class="col-lg-12">
          <h3 class="text-left mb-3">{{ pageTitle }}</h3>
        </div>
      </div>
      <div class="mt-3 container">
        <!-- tab start -->
        <el-tabs class="schoolPageBTabs" stretch v-model="activeTab">
          <el-tab-pane name="basicInfo">
            <span slot="label">
              <span>Basic Information</span>
            </span>
            <div class="form-group">
              <div class="">
                <h5 class="text-left student-form__title" id="v-step-StudentPersonalInformation">School Information</h5>
              </div>
              <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>School Name</label>
                  <input
                    type="text"
                    class="form-control form__input"
                    v-model="inputSchoolName"
                    :class="{ requiredFields: $v.inputSchoolName.$error }"
                    v-b-tooltip.focus
                    title="Tooltip directive content"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputSchoolName.$error">School name required</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>School Short Name</label>
                  <input type="text" class="form-control form__input" v-model="inputSchoolShortName" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>School Code</label>
                  <input type="text" class="form-control form__input" v-model="inputSchoolCode" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>School Type</label>
                  <input type="text" class="form-control form__input" v-model="inputSchoolType" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>School Group</label>
                  <el-select
                    v-model="inputSchoolUniversity"
                    :placeholder="lang('Select University')"
                    class="pro-edt-select"
                    style="margin-left: auto !important; width: 100%"
                  >
                    <el-option v-for="item in ddlUniversityList" :key="item.PK_UNI_ID" :label="item.UNI_Name" :value="item.PK_UNI_ID"> </el-option>
                  </el-select>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>School Reporting Group</label>
                  <input type="text" class="form-control form__input" v-model="inputSchoolGroup" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>School Approved Capacity</label>
                  <input type="text" class="form-control form__input" v-model="inputSchoolApproveCount" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>School Actual Capacity</label>
                  <input type="text" class="form-control form__input" v-model="inputSchoolActualCount" />
                </div>
              </div>
              <div class="">
                <h5 class="text-left student-form__title" id="v-step-StudentPersonalInformation">School Addresses</h5>
              </div>
              <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>School Address 1</label>
                  <input type="text" class="form-control form__input" v-model="inputSchoolAddress1" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>School Address 2</label>
                  <input type="text" class="form-control form__input" v-model="inputSchoolAddress2" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>School Postal Code</label>
                  <input type="text" class="form-control form__input" v-model="inputSchoolPostalCode" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>School City</label>
                  <input type="text" class="form-control form__input" v-model="inputSchoolCity" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>School Country</label>
                  <input type="text" class="form-control form__input" v-model="inputSchoolCountry" />
                </div>
              </div>

              <div class="">
                <h5 class="text-left student-form__title" id="v-step-StudentPersonalInformation">School Contact Information</h5>
              </div>
              <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Phone No</label>
                  <input type="text" class="form-control form__input" v-model="inputSchoolPhoneNo" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Fax No</label>
                  <input type="text" class="form-control form__input" v-model="inputSchoolFaxNo" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Email</label>
                  <input type="text" class="form-control form__input" v-model="inputSchoolEmail" />
                </div>
              </div>
              <div class="buttonArea">
                <div class="text-center mg-b-pro-edt custom-pro-edt-ds">
                  <button type="button" @click="saveSchoolInfo" id="v-step-SaveButton" class="btn btn-primary waves-effect waves-light m-r-10 float-right">
                    Save Basic Information
                  </button>
                </div>
              </div>
              <div class="whitespace-30"></div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="finance" v-if="!hideTabs">
            <span slot="label">
              <span>Finance</span>
            </span>
            <div class="form-group">
              <div class="">
                <h5 class="text-left student-form__title" id="v-step-StudentPersonalInformation">School Bank Account Information</h5>
              </div>
              <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Beneficiary Name</label>
                  <input
                    type="text"
                    class="form-control form__input"
                    v-model="inputSchoolBeneficiaryName"
                    :class="{ requiredFields: $v.inputSchoolBeneficiaryName.$error }"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputSchoolBeneficiaryName.$error">Beneficiary name required</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Beneficiary Address</label>
                  <input
                    type="text"
                    class="form-control form__input"
                    v-model="inputSchoolBeneficiaryAddress"
                    :class="{ requiredFields: $v.inputSchoolBeneficiaryAddress.$error }"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputSchoolBeneficiaryAddress.$error">Beneficiary address required</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Bank Name</label>
                  <input
                    type="text"
                    class="form-control form__input"
                    v-model="inputSchoolBankName"
                    :class="{ requiredFields: $v.inputSchoolBankName.$error }"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputSchoolBankName.$error">Bank Name required</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Account No</label>
                  <input
                    type="text"
                    class="form-control form__input"
                    v-model="inputSchoolAccountNo"
                    :class="{ requiredFields: $v.inputSchoolAccountNo.$error }"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputSchoolAccountNo.$error">Account No required</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Bank Code</label>
                  <input
                    type="text"
                    class="form-control form__input"
                    v-model="inputSchoolBankCode"
                    :class="{ requiredFields: $v.inputSchoolBankCode.$error }"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputSchoolBankCode.$error">Bank Code required</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Swift Code</label>
                  <input
                    type="text"
                    class="form-control form__input"
                    v-model="inputSchoolSwiftCode"
                    :class="{ requiredFields: $v.inputSchoolSwiftCode.$error }"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputSchoolSwiftCode.$error">Swift Code required</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Bank Branch</label>
                  <input
                    type="text"
                    class="form-control form__input"
                    v-model="inputSchoolBankBranch"
                    :class="{ requiredFields: $v.inputSchoolBankBranch.$error }"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputSchoolBankBranch.$error">Bank Branch required</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Branch Code</label>
                  <input
                    type="text"
                    class="form-control form__input"
                    v-model="inputSchoolBranchCode"
                    :class="{ requiredFields: $v.inputSchoolBranchCode.$error }"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputSchoolBranchCode.$error">Branch Code required</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Currency</label>
                  <input
                    type="text"
                    class="form-control form__input"
                    v-model="inputSchoolCurrency"
                    :class="{ requiredFields: $v.inputSchoolCurrency.$error }"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputSchoolCurrency.$error">Currency required</div>
                </div>
              </div>
              <div class="">
                <h5 class="text-left student-form__title" id="v-step-StudentPersonalInformation">Billing Setup</h5>
              </div>
              <div class="row form-group__wrapper">
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                  <label>Invoice Doc Name</label>
                  <input
                    type="text"
                    class="form-control form__input"
                    v-model="inputSchoolInvoiceDocName"
                    :class="{ requiredFields: $v.inputSchoolInvoiceDocName.$error }"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputSchoolInvoiceDocName.$error">Invoice Doc Name required</div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                  <label>Invoice Prefix</label>
                  <input
                    type="text"
                    class="form-control form__input"
                    v-model="inputSchoolInvoicePrefix"
                    :class="{ requiredFields: $v.inputSchoolInvoicePrefix.$error }"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputSchoolInvoicePrefix.$error">Invoice prefix required</div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                  <label>Credit Note Prefix</label>
                  <input
                    type="text"
                    class="form-control form__input"
                    v-model="inputSchoolCreditNotePrefix"
                    :class="{ requiredFields: $v.inputSchoolCreditNotePrefix.$error }"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputSchoolCreditNotePrefix.$error">Credit Note prefix required</div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                  <label>Receipt Prefix</label>
                  <input
                    type="text"
                    class="form-control form__input"
                    v-model="inputSchoolReceiptPrefix"
                    :class="{ requiredFields: $v.inputSchoolReceiptPrefix.$error }"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputSchoolReceiptPrefix.$error">Receipt prefix required</div>
                </div>
                <div class="row">
                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                    <el-checkbox v-model="inputSchoolToPrintBankDetails" label="Print Bank Details" border></el-checkbox>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                    <el-checkbox v-model="inputSchoolToPrintRemarksDetails" label="Print Remarks Details" border></el-checkbox>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                    <el-checkbox v-model="inputSchoolToPrintSpecial" label="Print Special Details" border></el-checkbox>
                  </div>
                </div>

                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <label>Invoice Remarks</label>
                  <textarea
                    type="text"
                    class="form-control form__input"
                    v-model="inputSchoolInvoiceRemarks"
                    :class="{ requiredFields: $v.inputSchoolInvoiceRemarks.$error }"
                  ></textarea>
                  <div class="requiredFieldsMsg" v-if="$v.inputSchoolInvoiceRemarks.$error">Invoice remarks required</div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <label>Receipt Remarks</label>
                  <textarea
                    type="text"
                    class="form-control form__input"
                    v-model="inputSchoolReceiptRemarks"
                    :class="{ requiredFields: $v.inputSchoolReceiptRemarks.$error }"
                  ></textarea>
                  <div class="requiredFieldsMsg" v-if="$v.inputSchoolReceiptRemarks.$error">Receipt remarks required</div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <label>Credit Note Remarks</label>
                  <textarea
                    type="text"
                    class="form-control form__input"
                    v-model="inputSchoolCRRemarks"
                    :class="{ requiredFields: $v.inputSchoolCRRemarks.$error }"
                  ></textarea>
                  <div class="requiredFieldsMsg" v-if="$v.inputSchoolCRRemarks.$error">Credit Note remarks required</div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <label>General Remarks</label>
                  <textarea
                    type="text"
                    class="form-control form__input"
                    v-model="inputSchoolGeneralRemarks"
                    :class="{ requiredFields: $v.inputSchoolGeneralRemarks.$error }"
                  ></textarea>
                  <div class="requiredFieldsMsg" v-if="$v.inputSchoolGeneralRemarks.$error">General remarks required</div>
                </div>
              </div>
            </div>
            <div class="buttonArea">
              <div class="text-center mg-b-pro-edt custom-pro-edt-ds">
                <button type="button" @click="saveSchoolInfo" id="v-step-SaveButton" class="btn btn-primary waves-effect waves-light m-r-10 float-right">
                  Save Finance Details
                </button>
              </div>
            </div>
            <div class="whitespace-30"></div>
          </el-tab-pane>
          <el-tab-pane name="course" v-if="!hideTabs">
            <span slot="label">
              <span>Course</span>
            </span>
            <div class="form-group">
              <table class="table attTable" v-if="coursesList.length > 0">
                <tr>
                  <th>{{ lang('Course Name') }}</th>
                  <th>{{ lang('Course Code') }}</th>
                  <th>{{ lang('Course Level') }}</th>
                  <th>{{ lang('Student Age') }}</th>
                </tr>
                <tr v-for="record in coursesList" v-bind:key="record.SC_FK_CourseID">
                  <td>
                    <a target="_blank" :href="'/schoolManagementForAdminEdit?id=' + record.SC_FK_CourseID">{{ record.CRS_Course_Name }}</a>
                  </td>
                  <td>{{ record.CRS_Course_Code }}</td>
                  <td>{{ record.CRS_Level }}</td>
                  <td>{{ record.CRS_Age }}</td>
                </tr>
              </table>
            </div>
          </el-tab-pane>
          <el-tab-pane name="semester" v-if="!hideTabs">
            <span slot="label">
              <span>Semester</span>
            </span>
            <div class="form-group">
              <div class="text-center mg-b-pro-edt custom-pro-edt-ds">
                <button type="button" @click="showAddSemesterModal" id="v-step-SaveButton" class="btn btn-primary waves-effect waves-light m-r-10 float-right">
                  Add Semester
                </button>
              </div>
              <b-modal id="addSemesterModal" size="lg" title="Semester" ok-only ok-variant="secondary" ok-title="Cancel" ref="addSemesterModal" hide-footer>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label>Semester Name</label>
                    <input type="text" class="form-control form__input" v-model="newSemesterName" />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label>Semester Duration</label>
                    <input type="text" class="form-control form__input" v-model="newSemesterDuration" />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label>Start Date</label>
                    <div class="date">
                      <el-date-picker
                        v-model="newSemesterStartDate"
                        format="dd/MM/yyyy"
                        value-format="dd/MM/yyyy"
                        type="date"
                        placeholder="Pick a date"
                      ></el-date-picker>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label>End Date</label>
                    <div class="date">
                      <el-date-picker
                        v-model="newSemesterEndDate"
                        format="dd/MM/yyyy"
                        value-format="dd/MM/yyyy"
                        type="date"
                        placeholder="Pick a date"
                      ></el-date-picker>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="showVoidSemester">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <hr class="custom-hr" />
                    <h3>Semester Details</h3>
                  </div>
                </div>
                <div class="row" v-if="showVoidSemester">
                  <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">Name</div>
                  <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">Start Date</div>
                  <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">End Date</div>
                  <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">Action</div>
                </div>
                <div class="row" v-if="showVoidSemester">
                  <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                    <input type="text" class="form-control form__input" v-model="semesterDetail.newName" />
                  </div>
                  <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                    <el-date-picker
                      v-model="semesterDetail.newStartDate"
                      format="dd/MM/yyyy"
                      value-format="dd/MM/yyyy"
                      type="date"
                      placeholder="Pick a date"
                    ></el-date-picker>
                  </div>
                  <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                    <el-date-picker
                      v-model="semesterDetail.newEndDate"
                      format="dd/MM/yyyy"
                      value-format="dd/MM/yyyy"
                      type="date"
                      placeholder="Pick a date"
                    ></el-date-picker>
                  </div>
                  <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                    <a href="#" @click="addSemesterDetail"><i class="fa fa-plus"></i></a>
                  </div>
                </div>
                <div v-if="semesterDetail.length > 0">
                  <div v-for="detailItem in semesterDetail" v-bind:key="detailItem.SEMD_DetailName">
                    <div class="row" v-if="semesterDetailsEdit.PK_SEMD_ID == detailItem.PK_SEMD_ID">
                      <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                        <input type="text" class="form-control form__input" v-model="semesterDetailsEdit.SEMD_DetailName" v-bind="detailItem.SEMD_DetailName" />
                      </div>
                      <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                        <el-date-picker
                          v-model="detailItem.SEMD_FromDate"
                          format="dd/MM/yyyy"
                          value-format="dd/MM/yyyy"
                          type="date"
                          placeholder="Pick a date"
                        ></el-date-picker>
                      </div>
                      <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                        <el-date-picker
                          v-model="detailItem.SEMD_ToDate"
                          format="dd/MM/yyyy"
                          value-format="dd/MM/yyyy"
                          type="date"
                          placeholder="Pick a date"
                        ></el-date-picker>
                      </div>
                      <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                        <a href="#" @click="saveSemesterDetail"><i class="fa fa-save"></i></a>
                        <a href="#" @click="cancelEditSemesterDetail"><i class="fa fa-close"></i></a>
                      </div>
                    </div>
                    <div v-else class="row">
                      <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                        {{ detailItem.SEMD_DetailName }}
                      </div>
                      <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                        {{ convertDatetime(detailItem.SEMD_FromDate) }}
                      </div>
                      <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                        {{ convertDatetime(detailItem.SEMD_ToDate) }}
                      </div>
                      <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                        <a href="#" @click="editSemesterDetail(detailItem)"><i class="fa fa-edit"></i></a>
                        <a href="#" @click="removeSemesterDetail(detailItem)"><i class="fa fa-remove"></i></a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <button v-on:click="saveAddNewSemester()" style="float: right" class="btn btn-primary waves-effect waves-light m-r-10">Save</button> &nbsp;
                    <button v-if="showVoidSemester" v-on:click="VoidSemester()" style="float: right" class="btn btn-danger waves-effect waves-light m-r-10">
                      Void
                    </button>
                  </div>
                </div>
              </b-modal>

              <div class="whitespace-30"></div>
              <div class="whitespace-30"></div>

              <table class="table attTable" v-if="semesterList.length > 0">
                <tr>
                  <th>{{ lang('Semester Name') }}</th>
                  <th>{{ lang('Start Date') }}</th>
                  <th>{{ lang('End Date') }}</th>
                  <th>{{ lang('Status') }}</th>
                  <th>{{ lang('Action') }}</th>
                </tr>
                <tr v-for="record in semesterList" v-bind:key="record.PK_Semester_ID">
                  <td>{{ record.SMT_Code }}</td>
                  <td>{{ record.SMT_From_convert }}</td>
                  <td>{{ record.SMT_To_convert }}</td>
                  <td>{{ record.SMT_Status }}</td>
                  <td>
                    <a target="_blank" @click="openEditSemester(record)"><i class="fa fa-table"></i></a>
                  </td>
                </tr>
              </table>
            </div>
          </el-tab-pane>
          <el-tab-pane name="fee" v-if="!hideTabs">
            <span slot="label">
              <span>Fees</span>
            </span>
            <div class="form-group">
              <el-select
                v-model="ddlFilterSem"
                :placeholder="lang('Select Semester')"
                class="pro-edt-select"
                @change="filterFeeMaster()"
                style="margin-left: auto !important"
              >
                <el-option v-for="item in semesterList" :key="item.PK_Semester_ID" :label="item.SMT_Code" :value="item.PK_Semester_ID"> </el-option>
              </el-select>

              <el-select
                v-model="ddlFilterLevel"
                :placeholder="lang('Select Level')"
                class="pro-edt-select"
                @change="filterFeeMaster()"
                style="margin-left: auto !important"
              >
                <el-option v-for="item in coursesList" :key="item.PK_Course_ID" :label="item.CRS_Level" :value="item.PK_Course_ID"> </el-option>
              </el-select>
              <button v-on:click="showAddFeeMasterModal()" style="float: right" class="btn btn-primary waves-effect waves-light m-r-10">Add Fee Master</button>
              <div class="whitespace-30"></div>
              <table class="table attTable" v-if="filteredFeeMasterlist.length > 0">
                <tr>
                  <th>{{ lang('Fee Name') }}</th>
                  <th>{{ lang('Level') }}</th>
                  <th>{{ lang('Type') }}</th>
                  <th>{{ lang('Start Date') }}</th>
                  <th>{{ lang('End Date') }}</th>
                  <th>{{ lang('Status') }}</th>
                  <th>{{ lang('Action') }}</th>
                </tr>
                <tr v-for="record in filteredFeeMasterlist" v-bind:key="record.PK_Course_Fee_Scheme_ID">
                  <td>{{ record.PPM_Fee_Scheme_Name }}</td>
                  <td>{{ record.CRS_Course_Name }}</td>
                  <td>{{ record.PPM_ClassType }}</td>
                  <td>{{ record.PPM_Validity_Start_Date }}</td>
                  <td>{{ record.PPM_Validity_End_Date }}</td>
                  <td>{{ record.PPM_Status }}</td>
                  <td>
                    <a target="_blank" @click="openEditFeeMaster(record)"><i class="fa fa-edit"></i></a>
                    <a target="_blank" @click="openPaymentFeeRulesModal(record)"><i class="fa fa-table"></i></a>
                  </td>
                </tr>
              </table>

              <b-modal id="addFeeMasterModal" size="lg" title="Fee Master" ok-only ok-variant="secondary" ok-title="Cancel" ref="addFeeMasterModal" hide-footer>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label>Fee Master Name</label>
                    <input type="text" class="form-control form__input" v-model="newFeeMasterName" />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label>Level</label>
                    <el-select
                      v-model="newFeeMasterSemester"
                      :placeholder="lang('Select Semester')"
                      class="pro-edt-select"
                      style="margin-left: auto !important"
                    >
                      <el-option v-for="item in semesterList" :key="item.PK_Semester_ID" :label="item.SMT_Code" :value="item.PK_Semester_ID"> </el-option>
                    </el-select>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label>Level</label>

                    <el-select v-model="newFeeMasterCourseID" :placeholder="lang('Select Level')" class="pro-edt-select" style="margin-left: auto !important">
                      <el-option v-for="item in coursesList" :key="item.PK_Course_ID" :label="item.CRS_Level" :value="item.PK_Course_ID"> </el-option>
                    </el-select>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label>Class Type</label>

                    <el-select
                      v-model="newFeeMasterClassType"
                      :placeholder="lang('Select Class Type')"
                      class="pro-edt-select"
                      style="margin-left: auto !important"
                    >
                      <el-option v-for="item in classTypeList" :key="item.PK_CTY_ID" :label="item.CTY_ClassType" :value="item.CTY_ClassType"> </el-option>
                    </el-select>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label>Currency</label>
                    <input type="text" class="form-control form__input" v-model="newFeeMasterCurrency" />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label>GST</label>
                    <input type="text" class="form-control form__input" v-model="newFeeMasterGSTAmount" />
                  </div>

                  <hr class="custom-hr" />
                  <div class="col-lg-12">
                    <button v-on:click="saveAddNewFeeMaster()" style="float: right" class="btn btn-primary waves-effect waves-light m-r-10">Save</button> &nbsp;
                    <button v-if="showVoidFeeMaster" v-on:click="voidFeeMaster()" style="float: right" class="btn btn-danger waves-effect waves-light m-r-10">
                      Void
                    </button>
                  </div>
                  <div class="whitespace-30"></div>
                  <div class="whitespace-30"></div>
                </div>
              </b-modal>

              <b-modal
                id="paymentFeeRulesModal"
                size="lg"
                title="Fee Master"
                ok-only
                ok-variant="secondary"
                ok-title="Cancel"
                ref="paymentFeeRulesModal"
                hide-footer
              >
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <el-select
                      v-model="ddlFilterSemD"
                      :placeholder="lang('Select One')"
                      class="pro-edt-select"
                      @change="filterFeesBySemd()"
                      style="margin-left: auto !important"
                    >
                      <el-option v-for="item in semDList" :key="item.PK_SEMD_ID" :label="item.SEMD_DetailName" :value="item.PK_SEMD_ID"> </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="row">
                  <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                      <label>Description</label>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                      <label>Category</label>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                      <label>Amount</label>
                    </div>
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                      <label>Taxable</label>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                      <label>Day</label>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">Action</div>
                  </div>
                  <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                      <input type="text" class="form-control form__input" v-model="newFeeItem.name" />
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                      <el-select
                        :placeholder="lang('Select Category')"
                        class="pro-edt-select"
                        v-model="newFeeItem.category"
                        style="margin-left: auto !important; width: 100%"
                      >
                        <el-option v-for="item in ddlPPDCalCat" :key="item" :label="item" :value="item"> </el-option>
                      </el-select>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                      <input type="text" class="form-control form__input" v-model="newFeeItem.amount" />
                    </div>
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                      <el-checkbox v-model="newFeeItem.taxable"></el-checkbox>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                      <input type="text" class="form-control form__input" v-model="newFeeItem.day" />
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                      <a href="#" @click="saveFeeDetail()"><i class="fa fa-plus"></i></a>
                    </div>
                  </div>
                  <div v-for="feeDetail in filteredFeeDetails" v-bind:key="feeDetail.PPD_Payee_Name">
                    <div class="row" v-if="feeDetail.PK_Course_Fee_Detail_ID == feeDetailsEdit.PK_Course_Fee_Detail_ID">
                      <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                        <input type="text" class="form-control form__input" :value="feeDetailsEdit.PPD_Payee_Name" />
                      </div>
                      <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                        <el-select
                          v-model="feeDetailsEdit.PPD_CalCategory"
                          :placeholder="lang('Select Category')"
                          class="pro-edt-select"
                          style="margin-left: auto !important; width: 100%"
                        >
                          <el-option v-for="item in ddlPPDCalCat" :key="item" :label="item" :value="item"> </el-option>
                        </el-select>
                      </div>
                      <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                        <input type="text" class="form-control form__input" :value="feeDetailsEdit.PPD_Amount" />
                      </div>
                      <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                        <el-checkbox :value="feeDetailsEdit.PPD_PaymentItemType === 'Taxable'"></el-checkbox>
                      </div>
                      <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                        <input type="text" class="form-control form__input" :value="feeDetailsEdit.PPD_PaymentTimeline" />
                      </div>
                      <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                        <a href="#" v-b-toggle="replaceStringSpace(feeDetailsEdit.PPD_Payee_Name)"><i class="fa fa-table"></i></a>
                        <a href="#"><i class="fa fa-trash"></i></a>
                      </div>
                    </div>
                    <div class="row" v-else>
                      <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                        {{ feeDetail.PPD_Payee_Name }}
                      </div>
                      <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                        {{ feeDetail.PPD_CalCategory }}
                      </div>
                      <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                        {{ feeDetail.PPD_Amount }}
                      </div>
                      <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                        {{ feeDetail.PPD_PaymentItemType }}
                      </div>
                      <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                        {{ feeDetail.PPD_PaymentTimeline }}
                      </div>
                      <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                        <a href="#" v-b-toggle="replaceStringSpace(feeDetail.PPD_Payee_Name)"><i class="fa fa-table"></i></a>
                        <a href="#"><i class="fa fa-trash"></i></a>
                      </div>
                    </div>
                    <b-collapse :id="replaceStringSpace(feeDetail.PPD_Payee_Name)" :accordion="feeDetail.PPD_Payee_Name" role="tabpanel" class="table">
                      <div class="row" style="padding: 10px 25px">
                        <div class="row">
                          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                            <label>Description</label>
                          </div>
                          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                            <label>Category</label>
                          </div>
                          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                            <label>Amount</label>
                          </div>
                          <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                            <label>Unit</label>
                          </div>
                          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                            <label>No. Week</label>
                          </div>
                          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">Action</div>
                        </div>
                        <div class="row">
                          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                            <input type="text" class="form-control form__input" v-model="newPaymentRuleRows.PPR_Name" />
                          </div>
                          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                            <el-select
                              v-model="newPaymentRuleRows.PPR_Category"
                              :placeholder="lang('Select Category')"
                              class="pro-edt-select"
                              style="margin-left: auto !important; width: 100%"
                            >
                              <el-option v-for="item in ddlPPRCat" :key="item" :label="item" :value="item"> </el-option>
                            </el-select>
                          </div>
                          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                            <input type="text" class="form-control form__input" v-model="newPaymentRuleRows.PPR_Value" />
                          </div>
                          <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                            <input type="text" class="form-control form__input" v-model="newPaymentRuleRows.PPR_Unit" />
                          </div>
                          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                            <input type="text" class="form-control form__input" v-model="newPaymentRuleRows.PPR_Timeline" />
                          </div>
                          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                            <a href="#" @click="savePaymentPlanRules(feeDetail)"><i class="fa fa-plus"></i></a>
                          </div>
                        </div>
                        <div v-if="feeDetail.discountRule != undefined">
                          <div class="row" v-for="drule in feeDetail.discountRule" v-bind:key="drule.PK_PPR_ID">
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                              {{ drule.PPR_Name }}
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                              {{ drule.PPR_Category }}
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                              <input style="width: 100%; padding: 0 8px" type="number" v-model="drule.PPR_Value" />
                            </div>
                            <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                              {{ drule.PPR_Unit }}
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                              {{ drule.PPR_Timeline }}
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2" style="display: flex; gap: 15px">
                              <a href="#" @click="updatePaymentPlanRules(feeDetail, drule)"><i class="fa fa-edit"></i></a>
                              <a href="#" @click="delPaymentPlanrules(feeDetail, drule)"><i class="fa fa-trash"></i></a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                </div>
              </b-modal>
            </div>
          </el-tab-pane>
        </el-tabs>
        <!-- tab End -->
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import DataSource from '../data/datasource'
import Vue from 'vue'
import moment from 'moment'
import { lang } from '../locale/index'
import { required } from 'vuelidate/lib/validators'

import Cookies from 'js-cookie'
export default {
  name: 'SchoolManagementForAdminEdit',
  data() {
    return {
      pageTitle: '',
      pageMode: '',
      hideTabs: true,
      inputSchoolName: '',
      inputSchoolShortName: '',
      inputSchoolCode: '',
      inputSchoolType: '',
      inputSchoolUniversity: '',
      inputSchoolLogo: '',
      inputSchoolAddress1: '',
      inputSchoolAddress2: '',
      inputSchoolAddress3: '',
      inputSchoolCity: '',
      inputSchoolCountry: '',
      inputSchoolPostalCode: '',
      inputSchoolFaxNo: '',
      inputSchoolPhoneNo: '',
      inputSchoolEmail: '',
      inputSchoolGroup: '',
      inputSchoolApproveCount: '',
      inputSchoolActualCount: '',
      inputSchoolStatus: '',

      /* finance */
      inputSchoolBusinessRegistrationNo: '',
      inputSchoolTaxRegistered: '',
      inputSchoolTaxRegisteredNo: '',
      inputSchoolGstOption: '',
      inputSchoolGSTRegNo: '',
      inputSchoolBeneficiaryName: '',
      inputSchoolBeneficiaryAddress: '',
      inputSchoolBankName: '',
      inputSchoolAccountNo: '',
      inputSchoolBankCode: '',
      inputSchoolSwiftCode: '',
      inputSchoolBankBranch: '',
      inputSchoolBranchCode: '',
      inputSchoolCurrency: '',

      inputSchoolInvoicePrefix: '',
      inputSchoolCreditNotePrefix: '',
      inputSchoolReceiptPrefix: '',
      inputSchoolToPrintBankDetails: '',
      inputSchoolToPrintRemarksDetails: '',
      inputSchoolToPrintSpecial: '',
      inputSchoolInvoiceRemarks: '',
      inputSchoolReceiptRemarks: '',
      inputSchoolCRRemarks: '',
      inputSchoolGeneralRemarks: '',
      inputSchoolInvoiceDocName: '',

      /*
      ,[SCH_Currency]
      ,[SCH_LegalName]
      ,[SCH_BeneficiaryName]
      ,[SCH_BeneficiaryAddress]
      ,[SCH_BankName]
      ,[SCH_BankBranch]
      ,[SCH_AccountNo]
      ,[SCH_BankCode]
      ,[SCH_BranchCode]
      ,[SCH_SwiftCode]
      ,[SCH_InvoicePrefix]
      ,[SCH_CreditNotePrefix]
      ,[SCH_ReceiptPrefix]
      ,[SCH_ToPrintBankDetails]
      ,[SCH_ToPrintRemarksDetails]
      ,[SCH_ToPrintSpecial]
      ,[SCH_InvoiceRemarks]
      ,[SCH_ReceiptRemarks]
      ,[SCH_CRRemarks]
      ,[SCH_GeneralRemarks]
      ,[SCH_InvoiceDocName]
      
      ,[SCH_TermsOfPayment]
      ,[SCH_Letterhead_Name1]
      ,[SCH_Letterhead_Account2]
      ,[SCH_Letterhead_Name2]
      ,[SCH_CardUpPaymentLink]
      ,[SCH_AccEmail]
      ,[SCH_PayNowLink]
      ,[SCH_BU_Code]
      ,[SCH_BankBalAccNo]
      ,[SCH_CurrencyName] 
      ,[SCH_CardupSecretKey]
      ,[SCH_FullName]
      */
      editSemesterId: '',
      editFeeMasterId: '',
      newSemesterDuration: '',
      newSemesterName: '',
      newSemesterStartDate: '',
      newSemesterEndDate: '',

      newFeeMasterName: '',
      newFeeMasterCourseID: '',
      newFeeMasterGSTAmount: '',
      newFeeMasterCurrency: '',
      newFeeMasterSemester: '',
      newFeeMasterClassType: '',
      showVoidFeeMaster: false,
      showVoidSemester: false,
      ddlFilterLevel: '',
      ddlFilterSem: '',
      ddlFilterSemD: '',
      ddlFilterFeeMaster: '',
      filteredFeeMasterlist: [],
      activeTab: '',
      semesterDetailsEdit: [],
      feeDetailsEdit: [],
      ddlUniversityList: [],
      schoolList: [],
      coursesList: [],
      semesterList: [],
      feeMasterList: [],
      currencyList: [],
      classTypeList: [],
      filteredFeeDetails: [],
      feeDetails: [],
      newPaymentRuleRows: [],
      newFeeItem: [],
      semesterDetail: [],
      semDList: [],
      ddlPPDCalCat: ['Course Fees', 'School Meal', 'Non Course Fees', 'Additional Language', 'Insurance', 'FPS'],
      ddlPPRCat: ['Staff Discount', 'Post-Rated Discounts', 'Sibling Discount', 'Pro-Rate Discount'],
      sortOptionsSelected: '',
      sortOptions: ['School Name (ASC)', 'School Name (DESC)'],
    }
  },
  async created() {
    this.$vs.loading()
    this.activeTab = 'basicInfo'

    await this.getUniversity()
    await this.getCurrencyList()
    await this.getClassType()

    if (this.$route.query.id != null || this.$route.query.id !== undefined) {
      this.pageMode = 'edit'
      this.pageTitle = lang('Edit School')
      await this.getSchoolInfo()
      await this.getSchoolLevel()
      await this.getSchoolSemester()
      await this.getSchoolFeeMaster()
      this.hideTabs = false
    } else {
      this.pageMode = 'add'
      this.pageTitle = lang('Add School')
    }
    this.$vs.loading.close()
  },
  validations: {
    //basic info
    inputSchoolName: { required },

    // finance
    inputSchoolBeneficiaryName: { required },
    inputSchoolBeneficiaryAddress: { required },
    inputSchoolBankName: { required },
    inputSchoolAccountNo: { required },
    inputSchoolBankCode: { required },
    inputSchoolSwiftCode: { required },
    inputSchoolBankBranch: { required },
    inputSchoolBranchCode: { required },
    inputSchoolCurrency: { required },

    inputSchoolInvoicePrefix: { required },
    inputSchoolCreditNotePrefix: { required },
    inputSchoolReceiptPrefix: { required },
    inputSchoolToPrintBankDetails: { required },
    inputSchoolToPrintRemarksDetails: { required },
    inputSchoolToPrintSpecial: { required },
    inputSchoolInvoiceRemarks: { required },
    inputSchoolReceiptRemarks: { required },
    inputSchoolCRRemarks: { required },
    inputSchoolGeneralRemarks: { required },
    inputSchoolInvoiceDocName: { required },

    validationGroupSave: ['inputSchoolName'],
  },
  methods: {
    lang,
    async addSemesterDetail() {
      this.$vs.loading()
      try {
        const response = await DataSource.shared.saveSemesterDetail(
          '',
          'Active',
          this.editSemesterId,
          this.semesterDetail.newName,
          this.semesterDetail.newStartDate,
          this.semesterDetail.newEndDate,
          'Active',
        )
        if (response) {
          if (response.code === '99') {
            console.log('getStudentMealsOption: Error!')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            console.log('getStudentMealsOption: No record!')
          } else {
            try {
              const resp = await DataSource.shared.getSemesterTermDetailsBySemIDOverrideSchId(this.editSemesterId, '', 'Active', this.$route.query.id)
              if (resp) {
                if (resp.Table.length > 0) {
                  this.semesterDetail = resp.Table
                  this.semesterDetail = this.semesterDetail.filter(x => {
                    return x.SEMD_Status != 'Void'
                  })
                }
              }
            } catch (e) {
              this.results = e
            }
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },
    async saveSemesterDetail() {
      try {
        const response = await DataSource.shared.saveSemesterDetail(
          this.semesterDetailsEdit.PK_SEMD_ID,
          'Active',
          this.semesterDetailsEdit.PK_Semester_ID,
          this.semesterDetailsEdit.SEMD_DetailName,
          this.semesterDetailsEdit.SEMD_FromDate,
          this.semesterDetailsEdit.SEMD_ToDate,
          'Active',
        )
        if (response) {
          if (response.code === '99') {
            console.log('getStudentMealsOption: Error!')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            console.log('getStudentMealsOption: No record!')
          } else {
            for (let i = 0; i < this.semesterDetail.length; i++) {
              if (this.semesterDetail[i].PK_SEMD_ID == this.semesterDetailsEdit.PK_SEMD_ID) {
                this.semesterDetail[i].SEMD_DetailName = this.semesterDetailsEdit.SEMD_DetailName

                this.semesterDetail[i].SEMD_FromDate = moment(this.semesterDetailsEdit.SEMD_FromDate).format('yyyy-MMM-DD')
                console.log(this.semesterDetailsEdit.SEMD_FromDate, 'SEMD_FromDate')
                console.log(this.semesterDetail[i].SEMD_FromDate, 'SEMD_FromDate')

                this.semesterDetail[i].SEMD_ToDate = moment(this.semesterDetailsEdit.SEMD_ToDate).format('yyyy-MMM-DD')
                console.log(this.semesterDetailsEdit.SEMD_ToDate, 'SEMD_ToDate')
                console.log(this.semesterDetail[i].SEMD_ToDate, 'SEMD_ToDate')
              }
            }
            this.semesterDetailsEdit = []
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async cancelEditSemesterDetail() {
      this.semesterDetailsEdit = []
    },
    async editSemesterDetail(item) {
      this.semesterDetailsEdit = item
    },
    async removeSemesterDetail(item) {
      try {
        const response = await DataSource.shared.saveSemesterDetail(
          item.PK_SEMD_ID,
          this.editSemesterId,
          item.SEMD_DetailName,
          item.SEMD_FromDate,
          item.SEMD_ToDate,
          'Void',
        )
        if (response) {
          if (response.code === '99') {
            console.log('getStudentMealsOption: Error!')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            console.log('getStudentMealsOption: No record!')
          } else {
            var purgeItem = this.semesterDetail.filter(x => {
              return x.PK_SEMD_ID == item.PK_SEMD_ID
            })
            console.log(purgeItem, this.semesterDetail.indexOf(purgeItem[0]))
            this.semesterDetail.splice(this.semesterDetail.indexOf(purgeItem[0]), 1)
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    replaceStringSpace(val) {
      return val.replace(/ /g, '')
    },
    convertDatetime(val) {
      return moment(val).format('DD MMM YYYY')
    },
    async updatePaymentPlanRules(feeDetail, dRule) {
      const response = await DataSource.shared.savePaymentPlanRules(dRule)
      alert(response.code === '1' ? 'Payment plan rule updated!' : 'An error has occured!')
    },
    async delPaymentPlanrules(feeDetail, dRule) {
      console.log(feeDetail, dRule)
      let removeIndex = feeDetail.discountRule.indexOf(dRule)
      dRule.PPR_Status = 'Void'
      dRule.PPR_Timeline = 0
      try {
        const response = await DataSource.shared.savePaymentPlanRules(dRule)
        if (response) {
          if (response.code === '1') {
            this.newPaymentRuleRows = []
            feeDetail.discountRule.splice(removeIndex, 1)
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            console.log('savePaymentPlanRules: No record!')
          } else {
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async savePaymentPlanRules(fkDetail) {
      this.newPaymentRuleRows.PPR_FK_Course_FEE_Detail_ID = fkDetail.PK_Course_Fee_Detail_ID
      this.newPaymentRuleRows.PPR_FK_School_ID = this.$route.query.id
      this.newPaymentRuleRows.PPR_FK_Course_ID = this.ddlFilterLevel
      this.newPaymentRuleRows.PPR_Status = 'Active'
      console.log(this.newPaymentRuleRows, 'this.newPaymentRuleRows')
      try {
        const resp = await DataSource.shared.savePaymentPlanRules(this.newPaymentRuleRows)
        if (resp) {
          if (resp.code === '1') {
            this.newPaymentRuleRows = []

            this.feeDetails.filter(async x => {
              if (x.PK_Course_Fee_Detail_ID == fkDetail.PK_Course_Fee_Detail_ID) {
                const respRule = await DataSource.shared.getPaymentPlanRulesByFKId(fkDetail.PK_Course_Fee_Detail_ID)
                let discountRuleData = respRule.Table
                if (respRule.Table != undefined && respRule.Table.length > 0) {
                  discountRuleData = discountRuleData.sort((a, b) => {
                    return a.PPR_Timeline - b.PPR_Timeline
                  })
                }

                this.$set(x, 'discountRule', discountRuleData)
              }
            })

            console.log('savePaymentPlanRules: Error!')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            console.log('savePaymentPlanRules: No record!')
          } else {
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async loadPaymentDetails(PK_Course_Fee_Scheme_ID, PPM_FK_Course_ID) {
      this.newPaymentRuleRows.PPR_FK_Course_ID = PPM_FK_Course_ID
      // get semesters details
      let paymentDetailsSEMDList = []
      try {
        const resp = await DataSource.shared.getPaymentPlanMasterDetailsById(PK_Course_Fee_Scheme_ID)
        if (resp) {
          if (resp.Table.length > 0) {
            this.feeDetails = resp.Table
            if (this.feeDetails.length > 0) {
              for (let i = 0; i < this.feeDetails.length; i++) {
                const respRule = await DataSource.shared.getPaymentPlanRulesByFKId(this.feeDetails[i].PK_Course_Fee_Detail_ID)
                let discountRuleData = respRule.Table
                if (respRule.Table != undefined && respRule.Table.length > 0) {
                  discountRuleData = discountRuleData.sort((a, b) => {
                    return a.PPR_Timeline - b.PPR_Timeline
                  })
                }

                this.$set(this.feeDetails[i], 'discountRule', discountRuleData)
              }
              if (this.ddlFilterSemD == '') {
                this.filteredFeeDetails = this.feeDetails.filter(x => {
                  return x.FK_Semester_Details_ID == undefined
                })
              } else {
                this.filteredFeeDetails = this.feeDetails.filter(x => {
                  return x.FK_Semester_Details_ID == this.ddlFilterSemD
                })
              }
            }
          }
        } else {
          console.log('Error')
        }
      } catch (e) {
        console.log('Error1' + e)
        this.feeDetails = []
        this.filteredFeeDetails = []
        this.results = e
      }
      this.$refs.paymentFeeRulesModal.show()
    },
    async openPaymentFeeRulesModal(feeMaster) {
      try {
        const resp = await DataSource.shared.getSemesterTermDetailsBySemIDOverrideSchId(this.ddlFilterSem, '', 'Active', this.$route.query.id)
        if (resp) {
          if (resp.Table.length > 0) {
            this.semDList = resp.Table
            var obj = new Object()
            obj.PK_SEMD_ID = ''
            obj.SEMD_DetailName = 'One Time'
            this.semDList.push(obj)
            this.ddlFilterSemD = ''
          }
        }
      } catch (e) {
        this.results = e
      }
      this.ddlFilterFeeMaster = feeMaster.PK_Course_Fee_Scheme_ID
      this.loadPaymentDetails(feeMaster.PK_Course_Fee_Scheme_ID, feeMaster.PPM_FK_Course_ID)
    },
    async showAddFeeMasterModal() {
      this.showVoidFeeMaster = false
      this.editFeeMasterId = ''
      this.newFeeMasterName = ''
      this.newFeeMasterCourseID = ''
      this.newFeeMasterGSTAmount = ''
      this.newFeeMasterCurrency = ''
      this.newFeeMasterSemester = ''
      this.newFeeMasterClassType = ''
      this.$refs.addFeeMasterModal.show()
    },
    async saveFeeDetail() {
      console.log(this.newFeeItem, 'this.newFeeItem')

      var postData = {
        FK_Course_Fee_Scheme_ID: this.ddlFilterFeeMaster,
        PPD_PaymentTimeline: this.newFeeItem.day,
        PPD_PaymentItemType: this.newFeeItem.taxable,
        PPD_CalCategory: this.newFeeItem.category,
        FK_Semester_Details_ID: this.ddlFilterSemD,
        PPD_Payee_Name: this.newFeeItem.name,
        PPD_Amount: this.newFeeItem.amount,
      }

      try {
        const resp = await DataSource.shared.saveFeeDetail(postData)
        if (resp) {
          this.newFeeItem = {}
          this.loadPaymentDetails(this.ddlFilterFeeMaster, this.ddlFilterLevel)
        }
      } catch (e) {
        this.results = e
      }
    },
    async showAddSemesterModal() {
      this.showVoidSemester = false
      this.$refs.addSemesterModal.show()
    },
    async filterFeesBySemd() {
      console.log(this.feeDetails, 'this.feeDetails')
      console.log(this.ddlFilterSemD, 'this.ddlFilterSemD')
      if (this.ddlFilterSemD == '') {
        this.filteredFeeDetails = this.feeDetails.filter(x => {
          console.log(x.FK_Semester_Details_ID, 'x.FK_Semester_Details_ID')
          return x.FK_Semester_Details_ID == undefined
        })
      } else {
        this.filteredFeeDetails = this.feeDetails.filter(x => {
          return x.FK_Semester_Details_ID == this.ddlFilterSemD
        })
      }
      console.log(this.filteredFeeDetails, 'this.filteredFeeDetails')
    },
    async filterFeeMaster() {
      console.log(this.ddlFilterSem, this.ddlFilterLevel)
      let selectedSem = this.semesterList.filter(a => {
        return a.PK_Semester_ID == this.ddlFilterSem
      })
      this.filteredFeeMasterlist = this.feeMasterList.filter(b => {
        return (
          this.ddlFilterLevel == b.PPM_FK_Course_ID &&
          b.PPM_Status == 'Active' &&
          //   && this.convertDatetime(b.PPM_Validity_Start_Date) == this.convertDatetime(selectedSem[0].SMT_From)
          this.convertDatetime(b.PPM_Validity_End_Date) == this.convertDatetime(selectedSem[0].SMT_To)
        )
      })
    },
    async voidFeeMaster() {
      try {
        let selectedSemester = this.semesterList.filter(a => {
          return a.PK_Semester_ID == this.newFeeMasterSemester
        })
        const resp = await DataSource.shared.saveFeeMaster(
          this.editFeeMasterId,
          this.$route.query.id,
          this.newFeeMasterName,
          this.newFeeMasterCourseID,
          this.newFeeMasterGSTAmount,
          this.newFeeMasterCurrency,
          this.newFeeMasterSemester,
          this.newFeeMasterClassType,
          'Void',
          this.convertDatetime(selectedSemester[0].SMT_From),
          this.convertDatetime(selectedSemester[0].SMT_To),
        )
        if (response) {
          if (response.code === '99') {
            console.log('getStudentMealsOption: Error!')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            console.log('getStudentMealsOption: No record!')
          } else {
          }
        }
      } catch (e) {
        this.results = e
      }
      await this.getSchoolFeeMaster()
      this.editFeeMasterId = ''
      this.newFeeMasterName = ''
      this.newFeeMasterCourseID = ''
      this.newFeeMasterGSTAmount = ''
      this.newFeeMasterCurrency = ''
      this.newFeeMasterSemester = ''
      this.newFeeMasterClassType = ''
      this.$refs.addFeeMasterModal.hide()
      this.showVoidFeeMaster = false
    },
    async saveAddNewFeeMaster() {
      this.showVoidFeeMaster = false
      try {
        let selectedSemester = this.semesterList.filter(a => {
          return a.PK_Semester_ID == this.newFeeMasterSemester
        })
        const resp = await DataSource.shared.saveFeeMaster(
          this.editFeeMasterId,
          this.$route.query.id,
          this.newFeeMasterName,
          this.newFeeMasterCourseID,
          this.newFeeMasterGSTAmount,
          this.newFeeMasterCurrency,
          this.newFeeMasterSemester,
          this.newFeeMasterClassType,
          'Active',
          this.convertDatetime(selectedSemester[0].SMT_From),
          this.convertDatetime(selectedSemester[0].SMT_To),
        )
        if (response) {
          if (response.code === '99') {
            console.log('getStudentMealsOption: Error!')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            console.log('getStudentMealsOption: No record!')
          } else {
          }
        }
      } catch (e) {
        this.results = e
      }
      await this.getSchoolFeeMaster()
      this.newFeeMasterName = ''
      this.newFeeMasterCourseID = ''
      this.newFeeMasterGSTAmount = ''
      this.newFeeMasterCurrency = ''
      this.newFeeMasterSemester = ''
      this.newFeeMasterClassType = ''
      this.$refs.addFeeMasterModal.hide()
    },
    async getClassType() {
      try {
        const resp = await DataSource.shared.getClassType(this.$route.query.id)
        if (resp) {
          if (resp.Table.length > 0) {
            this.classTypeList = resp.Table
          }
        } else {
          console.log('Error')
        }
      } catch (e) {
        this.results = e
      }
    },
    async getCurrencyList() {
      try {
        const resp = await DataSource.shared.getCurrencyValueDropdownlist()
        if (resp) {
          if (resp.Table.length > 0) {
            this.currencyList = resp.Table
            this.newFeeMasterCurrency = this.currencyList[0].SCH_Currency
          }
        } else {
          console.log('Error')
        }
      } catch (e) {
        this.results = e
      }
    },
    async getSchoolFeeMaster() {
      if (this.$route.query.id != null || this.$route.query.id !== undefined) {
        try {
          const resp = await DataSource.shared.getPaymentPlanMasterBySchId(this.$route.query.id)
          if (resp) {
            if (resp.Table.length > 0) {
              this.feeMasterList = resp.Table
              this.filterFeeMaster()
            }
          } else {
            console.log('Error')
          }
        } catch (e) {
          this.results = e
        }
      }
    },
    async getSchoolSemester() {
      if (this.$route.query.id != null || this.$route.query.id !== undefined) {
        try {
          const resp = await DataSource.shared.getAcademicYearBySchoolID(this.$route.query.id)
          if (resp) {
            if (resp.Table.length > 0) {
              this.semesterList = resp.Table
              this.semesterList = this.semesterList.sort((a, b) => {
                return a.SMT_From_convert - b.SMT_From_convert
              })
              this.ddlFilterSem = this.semesterList[0].PK_Semester_ID
            }
          } else {
            console.log('Error')
          }
        } catch (e) {
          this.results = e
        }
      }
    },
    async getSchoolLevel() {
      if (this.$route.query.id != null || this.$route.query.id !== undefined) {
        try {
          const resp = await DataSource.shared.getLevelSpecificSchool(this.$route.query.id)
          if (resp) {
            if (resp.Table.length > 0) {
              this.coursesList = resp.Table

              this.coursesList = this.coursesList.sort((a, b) => {
                return a.CRS_Age - b.CRS_Age
              })
              console.log(this.coursesList[0], 'this.coursesList[0]')
              this.ddlFilterLevel = this.coursesList[0].PK_Course_ID
              console.log(this.ddlFilterLevel, 'this.ddlFilterLevel')
            }
          } else {
            console.log('Error')
          }
        } catch (e) {
          this.results = e
        }
      }
    },
    async VoidSemester() {
      try {
        const resp = await DataSource.shared.saveSemester(
          this.editSemesterId,
          this.$route.query.id,
          this.newSemesterName,
          this.newSemesterStartDate,
          this.newSemesterEndDate,
          this.newSemesterDuration,
          'Void',
        )
        if (response) {
          if (response.code === '99') {
            console.log('getStudentMealsOption: Error!')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            console.log('getStudentMealsOption: No record!')
          } else {
          }
        }
      } catch (e) {
        this.results = e
      }
      await this.getSchoolSemester()
      this.editSemesterId = ''
      this.newSemesterName = ''
      this.newSemesterStartDate = ''
      this.newSemesterEndDate = ''
      this.$refs.addSemesterModal.hide()
      this.showVoidSemester = false
    },

    async openEditFeeMaster(feeMaster) {
      this.$refs.addFeeMasterModal.show()
      this.showVoidFeeMaster = true
      this.editFeeMasterId = feeMaster.PK_Course_Fee_Scheme_ID
      this.newFeeMasterName = feeMaster.PPM_Fee_Scheme_Name
      this.newFeeMasterCourseID = feeMaster.PPM_FK_Course_ID
      this.newFeeMasterGSTAmount = feeMaster.FK_GST
      this.newFeeMasterCurrency = feeMaster.PPM_Currency
      let selectedSem = this.semesterList.filter(a => {
        return (
          this.convertDatetime(a.SMT_From) == this.convertDatetime(feeMaster.PPM_Validity_Start_Date) &&
          this.convertDatetime(a.SMT_To) == this.convertDatetime(feeMaster.PPM_Validity_End_Date)
        )
      })
      this.newFeeMasterSemester = selectedSem[0].PK_Semester_ID
      this.newFeeMasterClassType = feeMaster.PPM_ClassType
      this.semesterDetailsEdit = []
    },
    async openEditSemester(semester) {
      this.$refs.addSemesterModal.show()
      this.showVoidSemester = true
      this.editSemesterId = semester.PK_Semester_ID
      this.newSemesterName = semester.SMT_Code
      this.newSemesterDuration = semester.SMT_Duration
      this.newSemesterStartDate = this.convertDatetime(semester.SMT_From)
      this.newSemesterEndDate = this.convertDatetime(semester.SMT_To)
      this.editSemesterId = semester.PK_Semester_ID
      // load semester detail
      //semesterID, semdID, SMT_Statuss

      try {
        const resp = await DataSource.shared.getSemesterTermDetailsBySemIDOverrideSchId(this.editSemesterId, '', 'Active', this.$route.query.id)
        if (resp) {
          if (resp.Table.length > 0) {
            this.semesterDetail = resp.Table
            this.semesterDetail = this.semesterDetail.filter(x => {
              return x.SEMD_Status != 'Void'
            })
          }
        }
      } catch (e) {
        this.results = e
      }
      console.log(this.semesterDetail)
    },
    async saveAddNewSemester() {
      this.showVoidSemester = false
      try {
        const resp = await DataSource.shared.saveSemester(
          this.editSemesterId,
          this.$route.query.id,
          this.newSemesterName,
          this.newSemesterStartDate,
          this.newSemesterEndDate,
          this.newSemesterDuration,
          'Active',
        )
        if (response) {
          if (response.code === '99') {
            console.log('getStudentMealsOption: Error!')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            console.log('getStudentMealsOption: No record!')
          } else {
          }
        }
      } catch (e) {
        this.results = e
      }
      await this.getSchoolSemester()
      this.newSemesterName = ''
      this.newSemesterStartDate = ''
      this.newSemesterEndDate = ''
      this.$refs.addSemesterModal.hide()
    },
    async saveSchoolInfo() {
      this.$v.validationGroupSave.$touch()
      if (this.pageMode == 'add') {
        let school = {}
        school.schID = ''
        school.name = this.inputSchoolName
        school.shortName = this.inputSchoolName
        school.code = this.inputSchoolCode
        school.type = this.inputSchoolType
        school.university = this.inputSchoolUniversity
        school.address1 = this.inputSchoolAddress1
        school.address2 = this.inputSchoolAddress2
        school.city = this.inputSchoolCity
        school.country = this.inputSchoolCountry
        school.postalCode = this.inputSchoolPostalCode
        school.faxNo = this.inputSchoolFaxNo
        school.phoneNo = this.inputSchoolPhoneNo
        school.email = this.inputSchoolEmail
        school.group = this.inputSchoolGroup
        school.approveCount = this.inputSchoolApproveCount
        school.actualCount = this.inputSchoolActualCount
        school.status = 'Active'
        console.log(JSON.stringify(school))
        try {
          const resp = await DataSource.shared.saveSchoolBasicInfo(JSON.stringify(school))
          if (resp) {
            if (resp.code === '99') {
              console.log('saveSchoolBasicInfo: Error!')
            } else if (resp.code === '88') {
              window.location.replace('/')
            } else if (resp.code === '2') {
              console.log('saveSchoolBasicInfo: No record!')
            } else {
              console.log(resp, 'data')
              window.location.replace('?id=' + resp.PK_SCH_ID)
            }
          }
        } catch (e) {
          this.results = e
        }
      } else {
      }
    },
    async getUniversity() {
      try {
        const resp = await DataSource.shared.getUniversity('', '')
        if (resp) {
          if (resp.Table.length > 0) {
            this.ddlUniversityList = resp.Table
          }
        } else {
          console.log('Error')
        }
      } catch (e) {
        this.results = e
      }
    },
    async getSchoolInfo() {
      this.schoolList = []
      try {
        if (this.$route.query.id != null || this.$route.query.id !== undefined) {
          const resp = await DataSource.shared.getSchoolInfoBySchoolID(this.$route.query.id)
          if (resp) {
            if (resp.Table.length > 0) {
              this.inputSchoolName = resp.Table[0].SCH_Name
              this.inputSchoolShortName = resp.Table[0].SCH_Short_Name
              this.inputSchoolCode = resp.Table[0].SCHl_code
              this.inputSchoolType = resp.Table[0].SCH_SchoolType

              this.inputSchoolAddress1 = resp.Table[0].SCH_Address1
              this.inputSchoolAddress2 = resp.Table[0].SCH_Address2
              this.inputSchoolPostalCode = resp.Table[0].SCH_Zip
              this.inputSchoolCity = resp.Table[0].SCH_City
              this.inputSchoolCountry = resp.Table[0].SCH_Country

              this.inputSchoolUniversity = resp.Table[0].SCH_University
              this.inputSchoolFaxNo = resp.Table[0].SCH_Fax
              this.inputSchoolPhoneNo = resp.Table[0].SCH_Contact
              this.inputSchoolEmail = resp.Table[0].SCH_Email
              this.inputSchoolGroup = resp.Table[0].SCH_Group
              this.inputSchoolApproveCount = resp.Table[0].SCH_ApprovedCount
              this.inputSchoolActualCount = resp.Table[0].SCH_ActualCount

              this.inputSchoolBeneficiaryName = resp.Table[0].SCH_BeneficiaryName
              this.inputSchoolBeneficiaryAddress = resp.Table[0].SCH_BeneficiaryAddress
              this.inputSchoolBankName = resp.Table[0].SCH_BankName
              this.inputSchoolAccountNo = resp.Table[0].SCH_AccountNo
              this.inputSchoolBankCode = resp.Table[0].SCH_BankCode
              this.inputSchoolSwiftCode = resp.Table[0].SCH_SwiftCode
              this.inputSchoolBankBranch = resp.Table[0].SCH_BankBranch
              this.inputSchoolBranchCode = resp.Table[0].SCH_BranchCode
              this.inputSchoolCurrency = resp.Table[0].SCH_Currency

              this.inputSchoolInvoicePrefix = resp.Table[0].SCH_InvoicePrefix
              this.inputSchoolCreditNotePrefix = resp.Table[0].SCH_CreditNotePrefix
              this.inputSchoolReceiptPrefix = resp.Table[0].SCH_ReceiptPrefix
              this.inputSchoolToPrintBankDetails = resp.Table[0].SCH_ToPrintBankDetails
              this.inputSchoolToPrintRemarksDetails = resp.Table[0].SCH_ToPrintRemarksDetails
              this.inputSchoolToPrintSpecial = resp.Table[0].SCH_ToPrintSpecial
              this.inputSchoolInvoiceRemarks = resp.Table[0].SCH_InvoiceRemarks
              this.inputSchoolReceiptRemarks = resp.Table[0].SCH_ReceiptRemarks
              this.inputSchoolCRRemarks = resp.Table[0].SCH_CRRemarks
              this.inputSchoolGeneralRemarks = resp.Table[0].SCH_GeneralRemarks
              this.inputSchoolInvoiceDocName = resp.Table[0].SCH_InvoiceDocName
            }
          } else {
            console.log('Error')
          }
        }
      } catch (e) {
        this.results = e
      }
    },
  },
}
</script>
